var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("payment-summary", {
        attrs: {
          "form-title": "Your selection so far",
          products: _vm.productsSummary,
        },
        on: { totalPrice: _vm.setTotalPrice },
      }),
      _vm._v(" "),
      !_vm.userHasStaffPaymentTypes
        ? _c("credit-card-form")
        : _c(
            "div",
            { staticClass: "form-payment" },
            [
              _vm.paymentOptions.length > 1
                ? _c("div", { staticClass: "payment-options" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-6" },
                        [
                          _c(
                            "el-button-group",
                            { staticClass: "toggle-options" },
                            [
                              _vm._l(_vm.paymentOptions, function (payment, i) {
                                return [
                                  _vm.showPaymentOption(payment)
                                    ? _c(
                                        "el-button",
                                        {
                                          key: i,
                                          attrs: {
                                            type:
                                              _vm.activePaymentIndex === i
                                                ? "primary"
                                                : "plain",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.activePaymentIndex = i
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(payment.name) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "keep-alive",
                [
                  _c(_vm.paymentOptions[_vm.activePaymentIndex].component, {
                    tag: "component",
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }